module.exports = __webpack_public_path__ + "static/img/go-pro-player.26361b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/go-pro-funnel/go-pro-player.jpg
// module id = y2a6
// module chunks = 35